module.exports = __webpack_public_path__ + "static/AgrosisImg-44c2d6bda71d4b9617d3f527e0944efe.jpg";